module.exports = __webpack_public_path__ + "img/GPTW_2023-2024.c1bff764.png";